import { render } from "./gsrcu020101.vue?vue&type=template&id=32a3ceee&scoped=true"
import script from "./gsrcu020101.vue?vue&type=script&lang=js"
export * from "./gsrcu020101.vue?vue&type=script&lang=js"

import "./gsrcu020101.vue?vue&type=style&index=0&id=32a3ceee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a3ceee"]])

export default __exports__